import React from 'react';
export function HeroSection() {
  return <section className="relative h-screen w-full overflow-hidden" data-id="element-64">
      {/* Background Image with Parallax */}
      <div className="absolute inset-0 w-full h-full parallax-bg" style={{
      backgroundImage: `url('https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/e5f16da6-fb97-4232-ab80-1922c65961ee/car-detailing-1.jpg')`
    }} data-id="element-65">
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/60 bg-gradient-to-b from-black/70 via-black/40 to-[#111111]" data-id="element-66"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-center items-center text-center px-6 md:px-6 pt-44 sm:pt-36 md:pt-32 overflow-hidden" data-id="element-67">
        <h1 className="flex flex-col items-center justify-center mb-6 w-full" data-id="element-68">
          <span className="text-3xl md:text-7xl lg:text-8xl font-black text-white uppercase tracking-wider md:tracking-widest leading-tight break-words max-w-full" data-id="element-69">
            Luxury Clean.
          </span>
          <span className="text-3xl md:text-7xl lg:text-8xl font-black text-transparent bg-clip-text bg-gradient-to-r from-white via-white to-gray-400 uppercase tracking-wider md:tracking-widest leading-tight break-words max-w-full" data-id="element-70">
            Ultimate Convenience.
          </span>
        </h1>

        <p className="text-base md:text-2xl text-white/90 font-inter max-w-3xl mb-10 font-light px-4" data-id="element-71">
          5-Star Rated Mobile Detailing — We Come to You Anywhere in Metro
          Phoenix
        </p>

        <div className="flex flex-col md:flex-row items-center gap-4 md:gap-6 w-full md:w-auto px-4" data-id="element-72">
          <a href="#booking" className="w-full md:w-auto bg-[#7FD4D4] text-black hover:bg-[#6BC4C4] px-8 py-4 font-bold text-lg uppercase tracking-wide rounded-sm transition-all transform hover:scale-105" data-id="element-73">
            Book Online
          </a>
          <a href="tel:602-641-5089" className="w-full md:w-auto border-2 border-white text-white hover:bg-white hover:text-black px-8 py-4 font-bold text-lg uppercase tracking-wide rounded-sm transition-all" data-id="element-74">
            Call 602-641-5089
          </a>
          <a href="#quote" className="w-full md:w-auto border border-white/40 text-white/80 hover:border-white hover:text-white px-8 py-4 font-medium text-lg uppercase tracking-wide rounded-sm transition-all backdrop-blur-sm" data-id="element-75">
            Get a Free Quote
          </a>
        </div>

        {/* Trust Indicators */}
        <div className="mt-8 md:mt-16 flex flex-col items-center px-4" data-id="element-76">
          <div className="w-24 h-1 bg-[#7FD4D4] mb-6" data-id="element-77"></div>
          <div className="flex flex-wrap justify-center gap-6 md:gap-12 text-white/90 font-medium text-sm md:text-base" data-id="element-78">
            <div className="flex items-center" data-id="element-79">
              <span className="text-[#FFD700] mr-2 text-lg" data-id="element-80">⭐⭐⭐⭐⭐</span>
              <span data-id="element-81">5.0 Google Rating</span>
            </div>
            <div className="flex items-center" data-id="element-82">
              <span className="mr-2" data-id="element-83">📝</span>
              <span data-id="element-84">150+ Reviews</span>
            </div>
            <div className="flex items-center" data-id="element-85">
              <span className="mr-2" data-id="element-86">🏆</span>
              <span data-id="element-87">Best Detailing 2025</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}